import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../api/api.service';
import { SettingsService } from '../settings/settings.service';
import { LoggerService } from '../shared/logger.service';
import { CasiProjectUser, CasiUserStory, IProjectFromWeb, User } from '../models/models.lib';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { Settings } from '../common/obj.lib';

export abstract class CasiUserStoryOwnerService extends BehaviorSubject<Array<any>> {
  public loading: boolean = false;
  private settings: Settings = this.settingsService.getSettings();

  constructor(
    private http: HttpClient,
    private settingsService: SettingsService
  ) {
    super([]);
  }

  public query(id: number): void {
    this.fetch(id).subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(id: number): Observable<CasiProjectUser[]> {
    this.loading = true;
    this.settings = this.settingsService.getSettings();
    return this.http.get(encodeURI(`${this.settings.apiUrl}/userstoryowner/byproject/${id}`))
      .pipe(
        map((response: any, i) => {
          return <IProjectFromWeb[]>response;
        }),
        map(r => r.map(x => new CasiProjectUser(x))),
        tap(() => (this.loading = false))
      )
  }
}

@Injectable({
  providedIn: 'root'
})
export class UserStoryOwnerService extends CasiUserStoryOwnerService {

  constructor(
    http: HttpClient,
    private settingService: SettingsService,
    private apiService: ApiService,
    private logger: LoggerService
  ) {
    super(http, settingService);
  }

  bulkSetOwners(users: any, userStory: CasiUserStory, byUser: string | undefined): Promise<any> {
    return this.apiService.postHttpCallAsPromise(`userstoryowner/bulkset`, { users, userStory, byUser }, 'postbulkSetOwners');
  }

  deleteByUser(userId: number, storyId: number): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`deleteuserstoryownerbyuser`, { userId, storyId }, 'putdeleteByUser');
  }

  // getProjectOwnerUsers(id: number): Promise<any> {
  //   this.loading = true;
  //   return this.apiService.getHttpCallAsPromise(`userstoryowner/byproject/${id}`, 'getProjectOwnerUsers')
  //     .then(data => {
  //       return data.map((d:any) => new CasiProjectUser(d));
  //     })
  //     .catch(err => Promise.reject(err))
  //     .finally(() => this.loading = false);
  // }

  notifyOwnersStatus(users: any, userStory: CasiUserStory, byUser: string | undefined): Promise<any> {
    return this.apiService.postHttpCallAsPromise(`userstoryowner/notify`, { users, userStory, byUser }, 'notifyOwnersStatus');
  }

  notifyRequestor(user: User, userStory: CasiUserStory, byUser: string | undefined): Promise<any> {
    return this.apiService.postHttpCallAsPromise(`userstoryrequestor/notify`, { user, userStory, byUser }, 'notifyRequestors');
  }

  //deleteByUser
}
